<template lang='pug'>
v-container(fluid class="pa-0")
  v-app-bar(app, flat, dense, fixed, dark, color='primary')
    v-app-bar-nav-icon(@click='toggleDrawerMenu')
    v-toolbar-title(class='subtitle-1') マイアクティビティ {{$store.getters["Login/additional"]}}
  v-row(class='mr-0 ml-0 pl-4 local-header')
    v-tabs(v-model="tab", @change="search()", color='primary')
      v-tab 日ビュー
      v-tab 週ビュー
      v-tab 月ビュー
  v-divider
  v-row(justify='end', class="mr-0 ml-0 px-4 py-2")
    v-icon(small) access_time
    .caption 現在のタイムゾーン：{{this.timezone}}

  v-container
    v-row(class='mx-0 mb-3')
      v-tooltip(bottom)
        template(v-slot:activator='{ on }')
          v-btn(class='pl-1 pr-3 mr-1', v-on='on', text, color='primary', @click='movePrev()')
            v-icon keyboard_arrow_left
            .body {{tab==dayTab ? '前日' : (tab==weekTab?'前週':'前月')}}
        span {{tab==dayTab ? '前日' : (tab==weekTab?'前週':'前月')}}
      v-card(min-width="85", width='85', flat, class="timecell", v-if="tab==dayTab")
        v-menu(v-model='targetDateMenu', :close-on-content-click='false',transition='scale-transition', offset-y)
          template(v-slot:activator="{ on }")
            v-text-field(height='24',v-model='targetDateDisp', label='対象日', v-on="on", dense, hide-details="auto", @change='moveTargetDay()')
          v-date-picker(v-model='targetDateDisp', @input='targetDateMenu = false; moveTargetDay()', no-title)
      
      v-tooltip(bottom)
        template(v-slot:activator='{ on }')
          v-btn(class='pr-1 pl-3', v-on='on', text, color='primary', @click='moveNext()')
            .body {{tab==dayTab ? '翌日' : (tab==weekTab?'翌週':'翌月')}}
            v-icon keyboard_arrow_right
        span {{tab==dayTab ? '翌日' : (tab==weekTab?'翌週':'翌月')}}
    .body-2(class='date__total mb-3') {{tab==weekTab?'週':(tab==dayTab ? '日' : '月')}}の合計時間：{{total}}

    v-divider
    v-expansion-panels(v-if='tab===weekTab', accordion, over, tile, flat, focusable, class='mb-8', class='activity-items')
      v-expansion-panel( active-class="primaryBackground")
        v-expansion-panel-header(class='date__title  py-2', height='24')
          .panel-header.list-input-group 週報
        v-expansion-panel-content
          .panel-content
            v-textarea(v-model="weekly.weeklyMessage", auto-grow, :placeholder="weekly.weeklyMessage == null ? '未投稿' : ''", class='weekly-textarea pt-0', solo, flat, @focus='addClassActive', @blur='removeClassActive')
            v-row(class='ma-0 pt-3', justify='end')
              v-btn(@click='cancelWeekly',small, depressed, color='grey lighten-1', class='mr-2') キャンセル
              v-btn(@click='confirmWeekly',small, depressed, color='primary', :disabled='inProcess') 保存

    v-divider
    v-expansion-panels(over, tile, flat, focusable, class='activity-items',v-model="dayPanel")
      v-expansion-panel(v-for="(itemDate, indexDate) in dates", :key="indexDate", :class="{'offrow':itemDate.calendar != null && itemDate.calendar.isOffDay == true}", active-class="primaryBackground")
        v-expansion-panel-header
          .panel-header.list-input-group
            span(class='date__title pr-3 py-2') {{itemDate.startedDateDisp}}
            span(class='date-total pr-3', v-if="!$store.getters['Login/ignoreTimesheet']") 合計時間：{{itemDate.total}}
            
            //- コメント
            v-card(flat, class='timecell timesheets__plan pr-3')
              v-text-field(height='24', v-model='itemDate.calendar.plan', label="予定・コメント", dense, v-if="itemDate.calendar != null", hide-details="auto", @change='savePlan(itemDate.calendar)', solo, flat, @focus='addClassActive', @blur='removeClassActive')
            
            v-card(min-width='130', width='130', flat, class='timecell pr-0', v-if="!$store.getters['Login/ignoreTimesheet'] && itemDate.calendar != null")
              v-select(height='24', :items='workTypesByOffDay(itemDate.calendar == null ? false : itemDate.calendar.isOffDay)', item-text="name", item-value='tenantWorkTypeId', v-model='itemDate.calendar.tenantWorkTypeIdAM', hide-details="auto", @change='changeAM(itemDate.calendar)', dense, width='80', :label='itemDate.calendar.isSameWorkType!=true?"午前":"全日"', solo, flat)
            
            v-card(min-width='130', width='130', flat, class='timecell pr-0', v-if="itemDate.calendar != null && itemDate.calendar.isSameWorkType!=true && !$store.getters['Login/ignoreTimesheet']")
              v-select(height='24', :items='workTypesByOffDay(itemDate.calendar == null ? false : itemDate.calendar.isOffDay)', item-text="name", item-value='tenantWorkTypeId', v-model='itemDate.calendar.tenantWorkTypeIdPM', hide-details="auto", @change='changePM(itemDate.calendar)', dense, width='80', label="午後", solo, flat)
            
            .all-day-checkbox(class='pr-4')
              v-checkbox(label="終日", v-model='itemDate.calendar.isSameWorkType', dense, hide-details="auto", @change='changeSameWorkType(itemDate.calendar)', v-if="itemDate.calendar != null && !$store.getters['Login/ignoreTimesheet']")
            
            span(class='date__holiday', v-if="itemDate.calendar != null && itemDate.calendar.dayComment != null && itemDate.calendar.dayComment != ''") {{itemDate.calendar.dayComment}}
        v-divider

        v-expansion-panel-content
          .panel-content(v-if='itemDate.timesheets.length > 0 || (itemDate.calendar != null && itemDate.calendar.approvals.length > 0)')
            //- 休暇
            template(v-if="itemDate.calendar != null && itemDate.calendar.approvals.length > 0")
              div(class='pb-8')
                .body-2(v-for="(item, index) in itemDate.calendar.approvals", :key="item.statusMessageId", class='approvals') 
                  span(class='approvals__item') {{item.posted}} 
                  span {{item.status}} [{{item.workTypeName}}] {{item.changedDisplayName}} {{item.changedComment}}
                
            v-list-item-content(v-for="(item, index) in itemDate.timesheets", :key="item.timesheetId", v-if="!$store.getters['Login/ignoreTimesheet']")              
              .list-input-group
                //- 開始日時
                v-card(min-width="85", width='85', flat, class="timecell", v-if="dateStyle!='input'")
                  v-menu(v-model='item.datemenu', :close-on-content-click='false',transition='scale-transition', offset-y)
                    template(v-slot:activator="{ on }")
                      v-text-field(height='24', v-model='item.startedDate', label='開始日', v-on="on", dense, width='120',hide-details="auto", @change='checkDateAndTime(item)')
                    v-date-picker(v-model='item.startedDate', @input='item.datemenu = false; checkDateAndTime(item);', no-title)
                v-card(min-width="200", width='200', flat, class="timecell pr-3", v-if="dateStyle=='input'")
                  v-text-field(height='24',v-model='item.startedDate', type='date', label='開始日', dense, hide-details="auto",@change='checkDateAndTime(item)')
                v-card(min-width="65", width='65', flat, class="timecell pr-3", v-if="timeStyle=='time'")
                  v-text-field(height='24',v-model='item.startedTime', type='time', dense, hide-details="auto",@change='checkDateAndTime(item)', class="centered-input", label='時間', single-line)
                v-card(min-width="65", width='65', flat, class="timecell pr-3", v-if="timeStyle!='time'")
                  v-text-field(height='24',v-model='item.startedTime2', type='text', dense, hide-details="auto", @change="checkTimeInput(item, 'startedTime2')", maxlength='5', class="centered-input", label='時間', single-line)
                
                //- 終了日時
                v-card(min-width="85", width='85', flat, class="timecell", v-if="dateStyle!='input'")
                  v-menu(v-model='item.timemenu', :close-on-content-click='false',transition='scale-transition', offset-y)
                    template(v-slot:activator="{ on }")
                      v-text-field(height='24',v-model='item.endedDate', label='終了日', v-on="on", dense, hide-details="auto", @change='checkDateAndTime(item)')
                    v-date-picker(v-model='item.endedDate', @input='item.timemenu = false; checkDateAndTime(item);', no-title)
                v-card(min-width="200", width='200', flat, class="timecell pr-3", v-if="dateStyle=='input'")
                  v-text-field(height='24',v-model='item.endedDate', type='date', label='終了日', dense, hide-details="auto", @change='checkDateAndTime(item)')
                v-card(min-width="65", width='65', flat, class="timecell pr-3", v-if="timeStyle=='time'")
                  v-text-field(height='24',v-model='item.endedTime', type='time', dense, hide-details="auto", @change='checkDateAndTime(item)', class="centered-input", label='時間', single-line)
                v-card(min-width="65", width='65', flat, class="timecell pr-3", v-if="timeStyle!='time'")
                  v-text-field(height='24',v-model='item.endedTime2', type='text', dense, hide-details="auto",@change="checkTimeInput(item, 'endedTime2')", maxlength='5', class="centered-input", label='時間', single-line)

                //- 休憩
                v-card(min-width="65", width='65', flat, class="timecell pr-3")
                  v-text-field(height='24',v-model='item.breakTimespan', type="number", dense, label="休憩(分)", :id="item.timesheetId + 'break'", hide-details="auto", @change='checkDateAndTime(item)', class="centered-input", hint)

                //- 合計
                v-card(min-width="65", width='65', flat, class="pr-3", class="timecell")
                  v-text-field(height='24',:value='CalcTotal(item)', type="text", dense, label="合計時間", :id="item.timesheetId + 'total'", readonly, disabled, hide-details="auto", class="centered-input")
                
                //- メモ
                v-card(flat, class="timecell timesheets__memo d-flex")
                  v-text-field(height='24',v-model='item.comment', label="メモ", dense, :id="item.timesheetId + 'memo'", hide-details="auto", @change='checkDateAndTime(item)')
                
                  //- ゴミ箱
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-btn(fab, outlined, x-small, color="error", @click='askToDeleteItem(item)', class='ml-3', v-on='on',)
                        svg(style="width:24px; height:24px", viewBox="0 0 24 24")
                          path(fill="currentColor" d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z")
                    span 削除
          .myactivity-status-message(v-if='itemDate.statusMessages.length > 0') 
            .subtitle-2.myactivity-status-message__title(class='pb-2') マイタイムライン
            .stasus-message__item-warp(v-if='itemDate.statusMessages.length > 0', class='my-timeline__item')
              .body-2.myactivity-status-message__items(v-for="(item, index) in itemDate.statusMessages", :key="item.statusMessageId")
                span(class='myactivity-status-message__item') {{item.updatedTime}}
                span {{item.message}}
                  span(v-html='item.emoji', class='myactivity-status-message__emoji')
          v-divider
    v-row(v-if="tab==dayTab", class="d-flex flex-column px-4")
      v-row
        v-col
          div(class="date__title") 該当日のプロジェクト
        v-col(class="d-flex flex-row-reverse")
          v-btn(rounded,dense,color='blue',class="white--text", @click="showChangeProjectDialog=true") {{targetDateDisp}} のプロジェクトを追加
      v-divider
      v-simple-table(class="project--table")
        template(v-slot:default)
          thead
            tr
              th プロジェクト
              th チケット
              th コメント
              th 時間
              th 合計:{{projectTotalTime}}
              th 
          tbody
            tr(v-for="(iobj, issueIndex) in presonalTimeDayIssues" :key="issueIndex")
              td(v-if="iobj.firstIssue", :rowspan="iobj.issueCount") {{iobj.project.projectName}}
              td
                span(class="px-2") {{iobj.issue.repositoryName}}
                span(class="px-2") {{iobj.issue.issueNumber == null ? "" : "#" + iobj.issue.issueNumber}}
                span(class="px-2") {{iobj.issue.issueNumber != null && iobj.issue.issueName != null ? iobj.issue.issueName : ""}}
              td {{iobj.issue.note}}
              td(width="150" class="")
                v-btn-toggle(v-model="iobj.inputMyself", mandatory, dense, @change="changeAutoOrSet(iobj)")
                  v-btn 自動計算
                  v-btn 手動入力
                v-card(min-width="85", width='85', flat, class="timecell pr-3", v-if="iobj.inputMyself==1")
                  v-text-field(height='24',v-model='iobj.projectTime', type='text', dense, hide-details="auto",@change="checkProjectTimeInput(iobj, 'projectTime')", @click:clear="checkProjectTimeInput(iobj, 'projectTime',true)", maxlength='5', class="centered-input", label='時間', single-line,clearable)
              td(width="220")
                v-text-field(height='24',v-model='iobj.finalTime', readonly, type='text', dense, hide-details="auto", maxlength='5', class="centered-input", label='計算結果')
              td(width="50")
                //- ゴミ箱
                v-tooltip(bottom)
                  template(v-slot:activator='{ on }')
                    v-btn(fab, outlined, x-small, color="error", @click='askToDeleteIssue(iobj)', class='ml-3', v-on='on',)
                      svg(style="width:24px; height:24px", viewBox="0 0 24 24")
                        path(fill="currentColor" d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z")
                  span 削除
    v-row(v-if="tab!=dayTab", class="d-flex flex-column px-4")
      v-row
        v-col
          div(class="date__title") プロジェクト集計
        v-col
          v-btn-toggle(v-model="personalReportType", mandatory, dense, @change="generatePersonalReports()")
            v-btn プロジェクト単位
            v-btn リポジトリ単位
            v-btn チケット番号単位
            v-btn コメント単位
            v-btn 詳細
      v-divider
      v-data-table(v-if="personalReportType==4", :items="personalReportDetail",:headers="perosnalReportDetailHeaders",item-key="personalTimeDayProjectIssueId",dense)
        template(v-slot:item.seconds="{ item }")
          span {{item.projectTime}}
        template(v-slot:item.issueNumber="{ item }")
          span {{item.issueNumber == null ? '' : '#' + item.issueNumber + ' ' + item.issueName}}
        template(v-slot:footer)
          div(style="width:100%; text-align:right") 合計時間 {{personalReportTotal}}
      v-data-table(v-if="personalReportType==0", :items="personalReportProjects",:headers="perosnalReportProjectHeaders",item-key="personalTimeDayProjectIssueId",dense)
        template(v-slot:item.seconds="{ item }")
          span {{item.projectTime}}
        template(v-slot:footer)
          div(style="width:100%; text-align:right") 合計時間 {{personalReportTotal}}
      v-data-table(v-if="personalReportType==1", :items="personalReportRepository",:headers="perosnalReportRepositoryHeaders",item-key="personalTimeDayProjectIssueId",dense)
        template(v-slot:item.seconds="{ item }")
          span {{item.projectTime}}
        template(v-slot:footer)
          div(style="width:100%; text-align:right") 合計時間 {{personalReportTotal}}
      v-data-table(v-if="personalReportType==2", :items="personalReportIssue",:headers="perosnalReportIssueHeaders",item-key="personalTimeDayProjectIssueId",dense)
        template(v-slot:item.seconds="{ item }")
          span {{item.projectTime}}
        template(v-slot:item.issueNumber="{ item }")
          span {{item.issueNumber == null ? '' : '#' + item.issueNumber + ' ' + item.issueName}}
        template(v-slot:footer)
          div(style="width:100%; text-align:right") 合計時間 {{personalReportTotal}}
      v-data-table(v-if="personalReportType==3", :items="personalReportNote",:headers="perosnalReportNoteHeaders",item-key="personalTimeDayProjectIssueId",dense)
        template(v-slot:item.seconds="{ item }")
          span {{item.projectTime}}
        template(v-slot:item.issueNumber="{ item }")
          span {{item.issueNumber == null ? '' : '#' + item.issueNumber + ' ' + item.issueName}}
        template(v-slot:footer)
          div(style="width:100%; text-align:right") 合計時間 {{personalReportTotal}}
  v-dialog(v-model='dialog', max-width='250')
    v-card
      v-card-title Koos Workspace
      v-card-text {{dialogMessage}}
      v-card-actions
        v-btn(text, @click='dialog = false') OK
  v-dialog(v-model='dialogDelete', max-width='250')
    v-card
      v-card-title Koos Workspace
      v-card-text タイムシートを削除してよろしいですか? 
      v-card-text 開始日時: {{recordToDelete == null ? '' : recordToDelete.started}} 
      v-card-actions
        v-spacer
        v-btn(text, @click='dialogDelete = false') キャンセル
        v-btn(text, @click='deleteItem(); dialogDelete = false') OK
  v-dialog(v-model='dialogDeleteIssue', max-width='350')
    v-card(v-if="recordToDeleteIssue!=null")
      v-card-title Koos Workspace
      v-card-text プロジェクトを削除してよろしいですか? 
      v-card-text(class="px-4")
        span(class="px-1") {{ recordToDeleteIssue.project.projectName }}
        span(class="px-1") {{ recordToDeleteIssue.issue.repositoryName}}
        span(class="px-1") {{ recordToDeleteIssue.issue.issueNumber==null ? "" : "#" + recordToDeleteIssue.issue.issueNumber + " "+ recordToDeleteIssue.issue.issueName}}
      v-card-actions
        v-spacer
        v-btn(text, @click='dialogDeleteIssue = false') キャンセル
        v-btn(text, @click='deleteIssue(); dialogDeleteIssue = false') OK
  v-dialog(v-model='dialogWorkType', max-width='400')
    v-card
      v-card-title Koos Workspace
      v-card-text 変更します。変更依頼コメントを記入お願いします。 
      v-card-text
        v-text-field(v-model='requestParam.comment') 
      v-card-actions
        v-spacer
        v-btn(text, @click='cancelRequest') キャンセル
        v-btn(text, @click='confirmRequest') OK

  change-project-dialog(v-if="showChangeProjectDialog",
        :showDialog.sync="showChangeProjectDialog",
        @close="showChangeProjectDialog = false; search()",
        :targetDate = "targetDateDisp")
</template>

<script>
import basic from '@/components/mixins/basic'
import moment from "moment-timezone"
import { detect } from 'detect-browser';
import ChangeProjectDialog from '@/components/ChangeProjectDialog'

export default {
  mixins: [basic],
  components: {
    "change-project-dialog": ChangeProjectDialog
  },
  computed: {
    items: { get() { return this.$store.state.Masters.Workers }} ,
    canStart: { get() { 
      if (this.timesheets == null) return false
      var toReturn = true
      this.timesheets.forEach(ts => {
        if (ts.ended == null || ts.ended == '') {
          toReturn = false;
        }
      });
      return toReturn
    }},
    canEnd: { get() { 
      if (this.timesheets == null) return false
      if (this.timesheets.length == 0) return false
      var toReturn = false
      this.timesheets.forEach(ts => {
        if (ts.ended == null || ts.ended == '') {
          toReturn = true;
        }
      });
      return toReturn
    }},
  },
  data() {
    return {
      timesheets : [],
      dates : [],
      browser : null,
      dateStyle: 'picker',
      timeStyle: 'text',
      dialog: false,
      dialogMessage: '',
      dialogDelete: false,
      dialogDeleteIssue: false,
      recordToDelete: null,
      recordToDeleteIssue: null,
      tab: null,
      targetDate: null,
      targetDateDisp: null,
      targetDateMenu: false,
      totalDuration: 0,
      total:'',
      workTypes: [],
      dialogWorkType: false,
      requestParam: {},
      requestSuccessMessage: null,
      AMOriginal: null,
      PMOriginal: null,
      weekly: {},
      weeklycomment: '',
      dialogWeekly: false,
      dateStart: null,
      dateEnd: null,
      inProcess: false,
      dayTab: 0,
      weekTab: 1,
      monthTab: 2,
      dayPanel:[],
      personalTimeDay: {},
      presonalTimeDayIssues: [],
      showChangeProjectDialog: false,
      projectTotalTime: '',
      personalReport: [],
      personalReportTotal: '',
      personalReportDetail: [],
      perosnalReportDetailHeaders: [
        {
          text: 'プロジェクト',
          value: 'projectName',
        },
        {
          text: '日付',
          value: 'date',
        },
        {
          text: 'リポジトリ',
          value: 'repositoryName',
        },
        {
          text: 'Issue',
          value: 'issueNumber',
        },
        {
          text: 'コメント',
          value: 'note',
        },
        {
          text: '時間',
          value: 'seconds',
        },
      ],
      personalReportProjects: [],
      perosnalReportProjectHeaders: [
        {
          text: 'プロジェクト',
          value: 'projectName',
        },
        {
          text: '時間',
          value: 'seconds',
        },
      ],
      personalReportRepository: [],
      perosnalReportRepositoryHeaders: [
        {
          text: 'プロジェクト',
          value: 'projectName',
        },
        {
          text: 'リポジトリ',
          value: 'repositoryName',
        },
        {
          text: '時間',
          value: 'seconds',
        },
      ],
      personalReportIssue: [],
      perosnalReportIssueHeaders: [
        {
          text: 'プロジェクト',
          value: 'projectName',
        },
        {
          text: 'リポジトリ',
          value: 'repositoryName',
        },
        {
          text: 'Issue',
          value: 'issueNumber',
        },
        {
          text: '時間',
          value: 'seconds',
        },
      ],
      personalReportNote: [],
      perosnalReportNoteHeaders: [
        {
          text: 'プロジェクト',
          value: 'projectName',
        },
        {
          text: 'リポジトリ',
          value: 'repositoryName',
        },
        {
          text: 'Issue',
          value: 'issueNumber',
        },
        {
          text: 'コメント',
          value: 'note',
        },
        {
          text: '時間',
          value: 'seconds',
        },
      ],
      personalReportType: 4
    }
  },
  mounted() {
    this.browser = detect()
    if (this.browser !== null) {
      if (this.browser.os.includes('iOS') || this.browser.os.includes('Android')) {
        this.dateStyle = 'input'
        this.timeStyle = 'time'
      }
    }
  },
  methods: {
    async masterReady (){
      this.targetDate = moment()
      this.workTypes = await this.$store.direct.dispatch.Calendar.getPersonalWorkTypes()
      await this.search()
    },
    async search () {
      if (this.targetDate == null) { return }
      this.targetDateDisp = this.targetDate.format('YYYY-MM-DD')
      if (this.tab == this.dayTab) {
        this.dateStart = this.targetDate.clone();
        this.dateEnd = this.targetDate.clone().add(0, 'd');
        this.personalTimeDay = await this.$store.direct.dispatch.PersonalTime.accessDayParam(this.targetDate.format('YYYY-MM-DD'))
        var ptotalsecond = 0
        this.presonalTimeDayIssues = this.personalTimeDay.projects.reduce((prev, current) => {
          var firstIssue = true
          return current.issues.reduce((prevIssue, currentIssue) => {
            var projectTime = this.getProjectTimeString(currentIssue.totalSetSeconds, null)
            var finalTime = this.getProjectTimeString(currentIssue.totalFinalSeconds, this.targetDate)
            ptotalsecond += currentIssue.totalFinalSeconds == null ? 0 : currentIssue.totalFinalSeconds
            prevIssue.push({
              project: current, 
              issue: currentIssue, 
              firstIssue: firstIssue, 
              issueCount: current.issues.length, 
              inputMyself: currentIssue.totalSetSeconds == null ? 0 : 1,
              projectTime:projectTime,
              finalTime: finalTime})
            firstIssue = false
            return prevIssue
          },prev)
        }, [])
        var ptotalMinutes = Math.round(ptotalsecond / 60)
        var ptotalHours = Math.floor(ptotalMinutes/60)
        ptotalMinutes = ptotalMinutes % 60

        this.projectTotalTime = ptotalHours.toString().padStart(2, '0') + ':' + ptotalMinutes.toString().padStart(2, '0')

      } else if (this.tab == this.weekTab) {
        this.dateStart = this.targetDate.clone().add(-1 * this.targetDate.isoWeekday() + 1, 'd');
        this.dateEnd = this.targetDate.clone().add(7 - this.targetDate.isoWeekday(), 'd');
        this.personalReport = await this.$store.direct.dispatch.PersonalTime.personalReport({startDate:this.dateStart.format('YYYY-MM-DD'), endDate:this.dateEnd.format('YYYY-MM-DD')})
        await this.generatePersonalReports()
      } else {
        this.dateStart =  moment([this.targetDate.year(), this.targetDate.month(),1])
        this.dateEnd =  moment([this.targetDate.year(), this.targetDate.month(),1]).add(1, 'M').add(-1, 'd')
        this.personalReport = await this.$store.direct.dispatch.PersonalTime.personalReport({startDate:this.dateStart.format('YYYY-MM-DD'), endDate:this.dateEnd.format('YYYY-MM-DD')})
        await this.generatePersonalReports()
      }
      const {dates, timesheets} = await this.$store.dispatch("Timesheet/getMyTimesheetWithStatus", {startDate: this.dateStart.format('YYYY-MM-DD'), endDate: this.dateEnd.format('YYYY-MM-DD')});
      this.dates = dates.sort((a,b) => {
        if (a.startedDate > b.startedDate) {
          return 1
        }
        return -1
      });
      this.timesheets = timesheets;
      this.totalDuration = this.timesheets.reduce((total, element) => {
        return total + parseInt(element.dulationMin) 
      }, 0)
      this.total = (Math.floor(this.totalDuration / 60)).toString() + ':' + (this.totalDuration % 60).toString().padStart(2, '0') 
      if (this.tab == this.weekTab) {
        this.weekly = await this.$store.dispatch("Calendar/getMyWeekly", this.dateStart.format('YYYY-MM-DD'))
        if (this.weekly == null) { this.weekly = {} }
      }
      this.dayPanel = this.dates.reduce((prev, current) => {
        if (current.startedDate == moment().format('YYYY-MM-DD') || this.tab==this.dayTab) {
          prev = this.dates.indexOf(current)
        }
        return prev
      }, null)
    },
    async generatePersonalReports() {
      var total = 0
      if (this.personalReportType == 4){
        // 詳細
        this.personalReportDetail = this.personalReport.map(obj => {
          total += obj.totalFinalSeconds == null ? 0 : obj.totalFinalSeconds
          return {
            projectName: obj.projectName,
            date: moment(obj.date).format('YYYY-MM-DD'),
            repositoryName: obj.repositoryName,
            issueNumber: obj.issueNumber,
            issueName: obj.issueName,
            note: obj.note,
            projectTime: this.getProjectTimeString(obj.totalFinalSeconds, moment(obj.date)),
            seconds: obj.totalFinalSeconds,
            personalTimeDayIssueId: obj.personalTimeDayIssueId
          }
        })
      }
      if (this.personalReportType == 0){
        // プロジェクトごと
        this.personalReportProjects = this.personalReport.reduce((prev, current) => {
          total += current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds
          var already = prev.reduce((prevD,currentD) => {return prevD != null ? prevD : (currentD.projectId == current.projectId ? currentD : null)}, null)
          if (already != null) {
            already.seconds += current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds
            already.projectTime = this.getProjectTimeString(already.seconds)
          } else {
            prev.push({
              projectName: current.projectName,
              projectId: current.projectId,
              seconds: current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds,
              projectTime: this.getProjectTimeString(current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds),
              personalTimeDayIssueId: current.personalTimeDayIssueId
            })
          }
          return prev
        },[])
      }
      if (this.personalReportType == 1){
        // リポジトリごと
        this.personalReportRepository = this.personalReport.reduce((prev, current) => {
          total += current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds
          var already = prev.reduce((prevD,currentD) => {return prevD != null ? prevD : ((currentD.projectRepositoryId == current.projectRepositoryId && currentD.projectId == current.projectId) ? currentD : null)}, null)
          if (already != null) {
            already.seconds += current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds
            already.projectTime = this.getProjectTimeString(already.seconds)
          } else {
            prev.push({
              projectName: current.projectName,
              projectId: current.projectId,
              repositoryName: current.repositoryName,
              projectRepositoryId: current.projectRepositoryId,
              seconds: current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds,
              projectTime: this.getProjectTimeString(current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds),
              personalTimeDayIssueId: current.personalTimeDayIssueId
            })
          }
          return prev
        },[])
      }
      if (this.personalReportType == 2){
        // Issueごと
        this.personalReportIssue = this.personalReport.reduce((prev, current) => {
          total += current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds
          var already = prev.reduce((prevD,currentD) => {return prevD != null ? prevD : ((currentD.projectRepositoryId == current.projectRepositoryId && currentD.projectId == current.projectId && currentD.issueNumber == current.issueNumber) ? currentD : null)}, null)
          if (already != null) {
            already.seconds += current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds
            already.projectTime = this.getProjectTimeString(already.seconds)
          } else {
            prev.push({
              projectName: current.projectName,
              projectId: current.projectId,
              repositoryName: current.repositoryName,
              issueNumber: current.issueNumber,
              issueName: current.issueName,
              projectRepositoryId: current.projectRepositoryId,
              seconds: current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds,
              projectTime: this.getProjectTimeString(current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds),
              personalTimeDayIssueId: current.personalTimeDayIssueId
            })
          }
          return prev
        },[])
      }
      if (this.personalReportType == 3){
        // Issueごと
        this.personalReportNote = this.personalReport.reduce((prev, current) => {
          total += current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds
          var already = prev.reduce((prevD,currentD) => {return prevD != null ? prevD : ((currentD.projectRepositoryId == current.projectRepositoryId && currentD.projectId == current.projectId && currentD.issueNumber == current.issueNumber && currentD.note == current.note) ? currentD : null)}, null)
          if (already != null) {
            already.seconds += current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds
            already.projectTime = this.getProjectTimeString(already.seconds)
          } else {
            prev.push({
              projectName: current.projectName,
              projectId: current.projectId,
              repositoryName: current.repositoryName,
              issueNumber: current.issueNumber,
              issueName: current.issueName,
              note: current.note,
              projectRepositoryId: current.projectRepositoryId,
              seconds: current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds,
              projectTime: this.getProjectTimeString(current.totalFinalSeconds == null ? 0 : current.totalFinalSeconds),
              personalTimeDayIssueId: current.personalTimeDayIssueId
            })
          }
          return prev
        },[])
      }

      this.personalReportTotal = this.getProjectTimeString(total)
    },
    getProjectTimeString(totalFinalSeconds, targetDate = null) {
      var textWhenNull = targetDate == null ? null : (targetDate.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD') ? "作業未終了のため未確定" :"作業がないため未確定")
      var minuteFinal = totalFinalSeconds == null ? null : Math.round(totalFinalSeconds / 60.0)
      var hoursFinal = minuteFinal == null ? null : Math.floor(minuteFinal / 60.0)
      minuteFinal = minuteFinal % 60
      return hoursFinal==null ? (textWhenNull) : hoursFinal.toString() + ':' + minuteFinal.toString().padStart(2, '0')
    },
    async changeAutoOrSet (obj) {
      if (obj.inputMyself == 0 && obj.issue.totalSetSeconds != null) {
        obj.issue.totalSetSeconds = null
        await this.$store.direct.dispatch.PersonalTime.updateIssueTime(obj.issue)
        this.search()
      }
    },
    workTypesByOffDay (isOffDay) {
      if (isOffDay) {
        return this.workTypes.filter(element => {
          return element.canUseInOffDay
        })
      }else{
        return this.workTypes.filter(element => {
          return element.canUseInWorkDay
        })
      }
    },
    async changeSameWorkType (calendar) {
      if (calendar.isSameWorkType && calendar.tenantWorkTypeIdAM != calendar.tenantWorkTypeIdPM) {
        calendar.tenantWorkTypeIdPM = calendar.tenantWorkTypeIdAM
        this.requestParam = { personalCalendarId:calendar.personalCalendarId, param: 'tenantWorkTypeIdPM', value: calendar.tenantWorkTypeIdPM, comment: '' }
        this.requestSuccessMessage = '勤務区分（午後）を更新しました'
        this.dialogWorkType = true;
      }
    },
    async cancelRequest() {
      this.dialogWorkType = false;
      this.search()
    },
    async confirmRequest() {
      await this.$store.dispatch("Calendar/updatePersonal", this.requestParam); 
      this.dialogWorkType = false;
      this.dispSuccess(this.requestSuccessMessage)
      this.search()
    },
    async changeAM (calendar) {
      if (calendar.isSameWorkType) {
        this.requestParam = { personalCalendarId:calendar.personalCalendarId, param: 'tenantWorkTypeId', value: calendar.tenantWorkTypeIdAM, comment: '' }
        this.requestSuccessMessage = '勤務区分（全日）を更新しました'
        this.dialogWorkType = true;
        return
      }
      this.requestParam = { personalCalendarId:calendar.personalCalendarId, param: 'tenantWorkTypeIdAM', value: calendar.tenantWorkTypeIdAM, comment: '' }
      this.requestSuccessMessage = '勤務区分（午前）を更新しました'
      this.dialogWorkType = true;
    },
    async changePM (calendar) {
      this.requestParam = { personalCalendarId:calendar.personalCalendarId, param: 'tenantWorkTypeIdPM', value: calendar.tenantWorkTypeIdPM }
      this.requestSuccessMessage = '勤務区分（午後）を更新しました'
      this.dialogWorkType = true;
    },
    async saveComment (item) {
      var param = { personalCalendarId:item.personalCalendarId, param: 'comment', value: item.comment }
      await this.$store.dispatch("Calendar/updatePersonal", param); 
      this.dispSuccess('コメントを更新しました')
    },
    async savePlan (item) {
      var param = { personalCalendarId:item.personalCalendarId, param: 'plan', value: item.plan }
      await this.$store.dispatch("Calendar/updatePersonal", param); 
      this.snackMessage = '予定を更新しました'
      this.snackbar = true
    },
    moveTargetDay() {
      this.targetDate = moment(this.targetDateDisp)
      this.search()
    },
    movePrev() {
      if (this.tab == this.dayTab) {
        this.targetDate = this.targetDate.clone().add(-1, 'd')
      } else if (this.tab == this.weekTab) {
        this.targetDate = this.targetDate.clone().add(-7, 'd')
      } else {
        this.targetDate = moment([this.targetDate.year(), this.targetDate.month(),1]).add(-1, 'M')
      }
      this.search()
    },
    moveNext() {
      if (this.tab == this.dayTab) {
        this.targetDate = this.targetDate.clone().add(1, 'd')
      } else if (this.tab == this.weekTab) {
        this.targetDate = this.targetDate.clone().add(7, 'd')
      } else {
        this.targetDate = moment([this.targetDate.year(), this.targetDate.month(),1]).add(1, 'M')
      }
      this.search()
    },
    askToDeleteItem(item) {
      this.recordToDelete = item
      this.dialogDelete = true
    },
    askToDeleteIssue(item) {
      this.recordToDeleteIssue = item
      this.dialogDeleteIssue = true
    },
    async deleteItem() {
      await this.$store.dispatch("Timesheet/delete", this.recordToDelete.timesheetId);
      await this.search()
    },
    async deleteIssue() {
      await this.$store.direct.dispatch.PersonalTime.deleteIssue(this.recordToDeleteIssue.issue);
      await this.search()
    },
    CalcTotal(item) {
      if (item.started == null || item.started == '') { return '----' }
      var start = item.startedGMTM
      var end = (item.ended == null || item.ended == '') ? moment() : item.endedGMTM
      var lunch = item.breakTimespan
      var dulation = moment.duration(end.diff(start)).add(lunch * -1, 'minutes')
      var seconds = Math.round(dulation.asMilliseconds()/1000)
      var totalMinutes = Math.round(seconds/60)
      var hours = Math.floor(totalMinutes / 60)
      var minutes = totalMinutes % 60
      var time = Math.floor(hours) + ":" + minutes.toString().padStart(2, '0')
      return time
    },
    checkTimeInput(object, column) {
      var time = object[column]
      if (time==null) { object[column] = null; return; }
      if (!time.match('^[/0-9:]*$')) { object[column] = null; return; }
      if (time.length > 5) { time = time.startedTime2.substring(0,5) }
      var array = time.split(':')
      if (array.length > 2) { object[column] = null; return; }
      if (time.length < 3) { object[column] = null; return; }
      if (array.length == 1 && time.length==5) { object[column] = null; return; }
      if (array.length == 1 && time.length == 3) { time = '0' + object[column] }
      if (array.length != 2 && time.length == 4 && time.match('^[/0-9]*$')) { array = [time.substring(0,2), time.substring(2)] }
      if (array.length != 2) { object[column] = null; return; }
      var hour = parseInt(array[0])
      var minute = parseInt(array[1])
      if (hour > 23 || hour < 0) { object[column] = null; return; }
      if (minute > 59 || minute < 0) { object[column] = null; return; }
      object[column] = hour.toString().padStart(2, '0') + ':' + minute.toString().padStart(2, '0')
      this.checkDateAndTime(object)
    },
    async checkProjectTimeInput(object, column, cleared = false)  {
      var time = object[column]
      if (time==null || cleared) {
        object[column] = null; 
        object.issue.totalSetSeconds = null
        await this.$store.direct.dispatch.PersonalTime.updateIssueTime(object.issue)
        this.search()
        return; 
      }
      if (!time.match('^[/0-9:]*$')) { object[column] = null; return; }
      if (time.length > 5) { time = time.startedTime2.substring(0,5) }
      var array = time.split(':')
      if (array.length > 2) { object[column] = null; return; }
      if (array.length == 1 && time.length==5) { object[column] = null; return; }
      if (array.length == 1 && time.length == 3) { time = '0' + object[column] }
      if (array.length == 1 && time.length == 2) { time = '00' + object[column] }
      if (array.length == 1 && time.length == 1) { time = '000' + object[column] }
      if (array.length != 2 && time.length == 4 && time.match('^[/0-9]*$')) { array = [time.substring(0,2), time.substring(2)] }
      if (array.length != 2) { object[column] = null; return; }
      var hour = parseInt(array[0])
      var minute = parseInt(array[1])
      if (hour < 0) { object[column] = null; return; }
      if (minute < 0) { object[column] = null; return; }
      var totalMinutes = hour * 60 + minute;
      minute = totalMinutes % 60
      hour = Math.floor(totalMinutes/60.0)
      object[column] = hour.toString().padStart(2, '0') + ':' + minute.toString().padStart(2, '0')
      var second = hour * 3600 + minute * 60
      object.issue.totalSetSeconds = second
      await this.$store.direct.dispatch.PersonalTime.updateIssueTime(object.issue)
      this.search()
    },
    async startSession() {
      await this.$store.dispatch("Timesheet/startSession", this.offsetMin);
      await this.search()
    },
    async endSession() {
      await this.$store.dispatch("Timesheet/endSession", this.offsetMin);
      await this.search()
    },
    async cancelWeekly () {
      var res = await this.$store.dispatch("Calendar/getMyWeekly", this.dateStart.format('YYYY-MM-DD'))
      this.weekly.weeklyMessage = res.weeklyMessage
    },
    async confirmWeekly () {
      if (this.inProcess) {return}
      this.inProcess = true
      try{
        await this.$store.dispatch("Calendar/updateMyWeekly", {targetMonday: this.dateStart.format('YYYY-MM-DD'), weeklyMessage: this.weekly.weeklyMessage})
        this.snackMessage = '週報の更新に成功しました。'
        this.snackbar = true
      }catch(error){
        this.dialogMessage = error.toString()
        this.dialog = true
      }
      this.inProcess = false
    },
    async checkDateAndTime(object) {
      var startedDate = (object.startedDate == null || object.startedDate == '') ? null : moment(object.startedDate)
      var startedTime = null
      var endedDate =  (object.endedDate == null || object.endedDate == '') ? null : moment(object.endedDate)
      var endedTime = null
      if (this.timeStyle == 'text') {
        startedTime = (object.startedTime2 == null || object.startedTime2 == '') ? null : object.startedTime2.split(':')
        endedTime = (object.endedTime2 == null || object.endedTime2 == '') ? null : object.endedTime2.split(':')
      } else {
        startedTime = (object.startedTime == null || object.startedTime == '') ? null : object.startedTime.split(':')
        endedTime = (object.endedTime == null || object.endedTime == '') ? null : object.endedTime.split(':')
      }
      if (startedTime != null && startedTime.length != 2) {
        object.startedTime = null
        object.startedTime2 = null
      }
      if (endedTime != null && endedTime.length != 2) {
        object.endedTime = null
        object.endedTime2 = null
      }
      var started = null
      var ended = null
      if (startedTime != null && startedDate != null) {
        started = moment({ year:startedDate.year(), month:startedDate.month(), date:startedDate.date(), hour:startedTime[0], minute:startedTime[1], second:0, millisecond:0}).format("YYYY-MM-DD HH:mm")
      }
      if (endedTime != null && endedDate != null) {
        ended = moment({ year:endedDate.year(), month:endedDate.month(), date:endedDate.date(), hour:endedTime[0], minute:endedTime[1], second:0, millisecond:0}).format("YYYY-MM-DD HH:mm")
      }
      try {
        if (object.started != started) {
          object.started = started
          var mobj = moment(started)
          var param = { TimesheetId:object.timesheetId, DateGMT: mobj.utc().format("YYYY-MM-DD HH:mm"), DateClient: started }
          var timesheet = await this.$store.dispatch("Timesheet/updateStarted", param);
          this.snackMessage = '開始時間を更新しました。'
          object.startedDate = timesheet.startedDate
          object.startedTime = timesheet.startedTime
          object.startedTime2 = timesheet.startedTime2
          this.snackbar = true
        }
        if (object.ended != ended) {
          object.ended = ended
          mobj = moment(ended)
          param = { TimesheetId:object.timesheetId, DateGMT: (ended == null || ended == "") ? null : mobj.utc().format("YYYY-MM-DD HH:mm"), DateClient: ended }
          timesheet = await this.$store.dispatch("Timesheet/updateEnded", param);
          this.snackMessage = '終了時間を更新しました。'
          object.endedDate = timesheet.endedDate
          object.endedTime = timesheet.endedTime
          object.endedTime2 = timesheet.endedTime2
          this.snackbar = true
        }
        if (object.commentOriginal != object.comment) {
          object.commentOriginal = object.comment
          param = { TimesheetId:object.timesheetId, Comment: object.comment }
          timesheet = await this.$store.dispatch("Timesheet/updateComment", param); 
          this.snackMessage = 'メモを更新しました。'
          this.snackbar = true
        }
        if (object.breakTimespanOriginal != object.breakTimespan) {
          object.breakTimespanOriginal = object.breakTimespan
          param = { TimesheetId:object.timesheetId, BreakTimespan: object.breakTimespan }
          timesheet = await this.$store.dispatch("Timesheet/updateBreakTimespan", param);
          this.snackMessage = '休憩時間(分)を更新しました。'
          this.snackbar = true
        }
      } catch (error) {
        this.dialogMessage = error.toString()
        this.dialog = true
      }
    },
    toggleDrawerMenu () {
      this.$emit('toggle')
    },
    addClassActive(e){
      var input = e.currentTarget.closest(".v-input__control")
      var activeItems = input.closest('.activity-items').querySelectorAll('.field--active')
      if(activeItems.length > 0){
        activeItems.forEach(e => {
          e.classList.remove('field--active')
        }); 
      }
      input.classList.add("field--active");
    },
    removeClassActive(e){
      var input = e.currentTarget.closest(".v-input__control")
      input.classList.remove("field--active");
    }
  }
};
</script>

<style lang='scss'>
@import "@/scss/variables.scss";

.date{
  &__title {
    font-size: 1rem !important;
    font-weight: bold !important;
    color:black;
  }
  &__holiday{
    font-size: .875rem !important;
  }
  &__total{
  font-size: 1rem !important;
  color:black;
  }
}
.timesheets{
  &__plan{
    min-width: 290px;
    width: calc(100% - 660px);
  }
  &__memo{
    min-width: 297px;
    width: calc(100% - 430px);
  }
}
.list-input-group{
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  align-items: center;
  min-height: 2rem;
}
.panel-header{
  .v-input .v-select__slot{
  font-size: .875rem !important;
  }
  .v-text-field.v-input--dense .v-input__append-inner .v-input__icon>.v-icon{
    margin-top: 0;
  }
  .v-text-field.v-input--dense:not(.v-text-field--outlined) input{
    padding: 2px 0;
  }
}
.panel-content {
  padding: 1rem 1rem 1.5rem 1rem;
  .v-list-item__content{
    padding-top: 0;
    padding-bottom:1.5rem;
    &:last-child{
      padding-bottom:0;
    }
  }
  .theme--light.v-card{
    background: inherit;
  }
  .timecell{
    padding: .625rem 0;
  }
}
.activity-items .v-expansion-panel-header,
.activity-items .v-expansion-panel--active > .v-expansion-panel-header{
  padding: .8125rem 1rem .6875rem 1rem;
  min-height: 64px;
}
.myactivity-status-message {
  padding: 0 1rem 1rem 1rem;
  &__title{
    font-size: 1rem !important;
  }
  &__items{
    text-indent: -3.25rem;
    padding-left: 3.25rem;
    margin-bottom: .25rem;
  }
  &__item{
    padding-right: 1rem;
  }
  &__emoji{
    img{
      margin-left: .1rem;
      vertical-align: -0.15rem;
      width: .875rem;
      height: .875rem;
    }
    .emoji-sizer{
      width: .875rem;
      height: .875rem;
    }
  }
}
.all-day-checkbox{
  .v-input{
    margin: 0;
    padding: 0;
  }
}
.approvals {
  &__item{
    padding-right: 1rem;
  }
  text-indent: -6.75rem;
  padding-left: 6.75rem;
  margin-bottom: .25rem;
}
.weekly-my-activity {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.weekly-textarea textarea {
  font-size: 0.875rem;
  line-height: 1.375rem;
}
.project--table {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: lightgray;
}
</style>